// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aLRj","delete":"styles_delete__1wyEV","update":"styles_update__2d_6r","add":"styles_add__MYjP7"};